var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTuning2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1667 4.66602C12.1667 6.04673 11.0474 7.16602 9.66668 7.16602C8.28596 7.16602 7.16668 6.04673 7.16668 4.66602C7.16668 3.2853 8.28596 2.16602 9.66668 2.16602C11.0474 2.16602 12.1667 3.2853 12.1667 4.66602ZM9.66668 6.16602C10.4951 6.16602 11.1667 5.49444 11.1667 4.66602C11.1667 3.83759 10.4951 3.16602 9.66668 3.16602C8.83825 3.16602 8.16668 3.83759 8.16668 4.66602C8.16668 5.49444 8.83825 6.16602 9.66668 6.16602Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83334 11.3327C3.83334 12.7134 4.95263 13.8327 6.33334 13.8327C7.71406 13.8327 8.83334 12.7134 8.83334 11.3327C8.83334 9.95197 7.71406 8.83268 6.33334 8.83268C4.95263 8.83268 3.83334 9.95197 3.83334 11.3327ZM6.33334 12.8327C5.50492 12.8327 4.83334 12.1611 4.83334 11.3327C4.83334 10.5043 5.50492 9.83268 6.33334 9.83268C7.16177 9.83268 7.83334 10.5043 7.83334 11.3327C7.83334 12.1611 7.16177 12.8327 6.33334 12.8327Z",
    fill: "#3B82F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 11.305C9.50001 11.0289 9.72387 10.805 10 10.805H14.6667C14.9428 10.805 15.1667 11.0289 15.1667 11.305C15.1667 11.5812 14.9428 11.805 14.6667 11.805H10C9.72387 11.805 9.50001 11.5812 9.50001 11.305Z",
    fill: "#3B82F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 4.13836C6.27615 4.13836 6.50001 4.36222 6.50001 4.63836C6.50001 4.9145 6.27615 5.13836 6.00001 5.13836L1.33334 5.13836C1.0572 5.13836 0.833344 4.9145 0.833344 4.63836C0.833344 4.36222 1.0572 4.13836 1.33334 4.13836L6.00001 4.13836Z",
    fill: "#3B82F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833344 11.305C0.833344 11.0289 1.0572 10.805 1.33334 10.805H2.66668C2.94282 10.805 3.16668 11.0289 3.16668 11.305C3.16668 11.5812 2.94282 11.805 2.66668 11.805H1.33334C1.0572 11.805 0.833344 11.5812 0.833344 11.305Z",
    fill: "#3B82F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.13836C14.9428 4.13836 15.1667 4.36222 15.1667 4.63836C15.1667 4.9145 14.9428 5.13836 14.6667 5.13836H13.3333C13.0572 5.13836 12.8333 4.9145 12.8333 4.63836C12.8333 4.36222 13.0572 4.13836 13.3333 4.13836H14.6667Z",
    fill: "#3B82F6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTuning2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Tuning 2.62638fc1a689656c35f35d9909605b46.svg";